import type { AxiosResponse } from 'axios';
import { appAxios } from 'utils/appAxios';
import { usersApi } from './api';

export type UsersMeResponse = Required<{
  id: number;
  email: string;
}>;
export const getUsersMe = async (): Promise<AxiosResponse> => {
  return await appAxios.get(`${usersApi.path}/me`);
};
